import { render, staticRenderFns } from "./GoodsClassify.vue?vue&type=template&id=341e3fad&"
import script from "./GoodsClassify.vue?vue&type=script&lang=js&"
export * from "./GoodsClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports